function getFragmentUrl(name, version) {
  return `/fragments/${name}/${version}`;
}
export {
  getFragmentUrl as g
};
//# sourceMappingURL=helpers.js.map
